import { ComponentProps } from "./types";
import Default from "./variants/Default";
import HeaderLink from "./variants/HeaderLink";
import Source from "./variants/Source";

export default function Stats({ ...props }: ComponentProps) {
  const { variant = "default" } = props;

  switch (variant) {
    case "header-link":
      return <HeaderLink {...props} />;
    case "source":
      return <Source {...props} />;
    default:
      return <Default {...props} />;
  }
}
